import type { en } from './en';

export const pl: typeof en = {
    app_loading:             "Ładowanie...",
    app_sign_in_tab:         "Zaloguj się",
    app_sign_up_tab:         "Zarejestruj się",

    sign_in_email:           "Email",
    sign_in_password:        "Hasło",
    sign_in_submit:          "Zaloguj się",
    sign_in_submitting:      "Logowanie...",

    sign_up_full_name:       "Imię i nazwisko",
    sign_up_email:           "Email",
    sign_up_password:        "Hasło",
    sign_up_submit:          "Utwórz konto",
    sign_up_submitting:      "Tworzenie konta...",

    dashboard_title:         "Projekty",
    dashboard_empty:         "Brak projektów. Utwórz jeden z menu konta.",
    dashboard_open_project:  "Otwórz jako nowy projekt",

    code_pane_changes:       "Zmiany",
    code_pane_diff:          "Diff",
    code_pane_explorer:      "Eksplorator",
    code_pane_editor:        "Edytor",
    code_edit_mode_on:       "Włącz tryb edycji",
    code_edit_mode_off:      "Wyłącz tryb edycji",
    code_no_files:           "Brak otwartych plików",
    code_file_deleted:       "Ten plik został usunięty",
    code_collapse_tree:      "Zwiń drzewo",
    code_more_actions:       "Więcej akcji",
    code_find:               "Znajdź",

    nav_code:                "Kod",
    nav_review:              "Przegląd",
    nav_deploy:              "Wdrożenie",
    nav_agent:               "Agent",

    deploy_title:            "Wdrożenie",
    deploy_empty:            "Brak skonfigurowanych wdrożeń",
    deploy_btn_frontend:     "Wdróż Frontend",
    deploy_btn_backend:      "Wdróż Backend",
    deploy_running:          "Wdrażam…",
    deploy_logs_title:       "Logi",
    deploy_logs_clear:       "Wyczyść",
    deploy_custom_placeholder: "Nazwa serwisu…",
    deploy_btn_custom:       "Wdróż",
    deploy_stop:             "Stop",

    account_menu_label:      "Menu konta",
    account_no_projects:     "Brak projektów",
    account_new_project:     "+ Nowy projekt",
    account_close_project:   "Zamknij projekt",
    account_settings:        "Ustawienia",
    account_setup_agent:     "Konfiguruj agenta",
    account_sign_out:        "Wyloguj się",

    settings_title:          "Ustawienia",
    settings_tab_appearance: "Wygląd",
    settings_tab_claude:     "Claude",
    settings_tab_tabs:       "Karty",
    settings_tab_ssh_keys:   "Klucze",
    settings_theme:          "Motyw",
    settings_language:       "Język",
    settings_max_open_tabs_desktop: "Maks. otwartych kart (desktop)",
    settings_max_open_tabs_mobile:  "Maks. otwartych kart (mobile)",
    settings_claude_model:         "Model",
    settings_claude_model_default: "Domyślny",
    settings_claude_effort:        "Nakład pracy",
    settings_claude_effort_default: "Domyślny",
    settings_claude_effort_low:    "Niski",
    settings_claude_effort_medium: "Średni",
    settings_claude_effort_high:   "Wysoki",
    settings_claude_effort_max:    "Maksymalny",
    settings_model_search:         "Szukaj modeli…",
    settings_model_loading:        "Ładowanie modeli…",
    settings_model_none:           "Brak pasujących modeli",
    settings_model_custom:         "Użyj:",
    settings_cancel:         "Anuluj",
    settings_save:           "Zapisz",

    new_project_title:       "Nowy projekt",
    new_project_placeholder: "Nazwa projektu",
    new_project_cancel:      "Anuluj",
    new_project_create:      "Utwórz",

    agent_placeholder:       "Opisz zadanie...",
    agent_send:              "Wyślij",
    agent_stop:              "Zatrzymaj",
    agent_thinking:          "Myślę…",
    agent_working:           "Pracuję…",
    agent_approve:           "Zezwól",
    agent_approve_always:    "Zawsze zezwól",
    agent_deny:              "Odrzuć",
    agent_permission_responded: "Odpowiedź wysłana",
    agent_new_session:          "Nowa sesja",
    agent_close_session:        "Zamknij sesję",
    agent_close_session_confirm: "Zamknąć tę sesję?",
    agent_session_settings:     "Ustawienia sesji",
    agent_context_toggle:        "Przełącz kontekst pliku",
    agent_context_remove:        "Usuń kontekst pliku",
    agent_readonly_toggle:       "Przełącz tryb tylko do odczytu (nie edytuj kodu)",
    agent_backend:               "Backend",
    agent_backend_json:          "JSON",
    agent_backend_vscode:        "VS Code",

    file_open_dir:           "Otwórz katalog",
    file_empty:              "Pusty",
    file_empty_dir:          "Pusty katalog",
    file_delete_title:       "Usuń",
    file_delete_confirm:     "Trwale usunąć \"{path}\" z dysku? Tej operacji nie można cofnąć.",
    file_delete_btn:         "Usuń",
    file_add_to_context:     "Dodaj do kontekstu",
    file_create_folder_title: "Utwórz folder",
    file_create_folder_placeholder: "Nazwa folderu",
    file_create_folder_btn:  "Utwórz",
    file_create_file_title:  "Utwórz plik",
    file_create_file_placeholder: "Nazwa pliku",
    file_create_file_btn:    "Utwórz",
    file_rename_title:       "Zmień nazwę",
    file_rename_placeholder: "Nowa nazwa",
    file_rename_btn:         "Zmień nazwę",

    review_changes:          "Zmiany",
    review_staged:           "Staged",
    review_unstaged:         "Niestaged",
    review_untracked:        "Nieśledzone",
    review_conflicts:        "Konflikty",
    review_conflict_label:   "konflikt",
    review_resolved:              "Rozwiązane",
    review_resolved_label:        "rozwiązano",
    review_pending_stash_merge:   "Po zatwierdzeniu lokalne zmiany zostaną ponownie zastosowane i może być wymagane kolejne scalanie.",
    review_accept_mine:      "Zachowaj moje",
    review_accept_theirs:    "Zachowaj ich",
    review_accept_both:      "Zachowaj oba",
    review_accept_committed: "Zachowaj zatwierdzone",
    review_accept_stash:     "Zachowaj stash",
    review_save:             "Zapisz",
    review_edit:             "Edytuj",
    review_done_editing:     "Zakończ edycję",
    review_ctx_stage:        "Dodaj",
    review_ctx_unstage:      "Usuń",
    review_ctx_revert:       "Przywróć",
    review_untracked_short:  "U",
    review_no_changes:       "Brak zmian",
    review_no_commits:       "Brak commitów",
    review_detached_head:    "Odłączone HEAD",
    review_select_file:      "Wybierz plik, aby zobaczyć diff",
    review_no_changes_for_file: "Brak zmian dla {path}",
    review_no_git:           "Brak repozytorium git",
    review_no_git_desc:      "Projekt \"{name}\" nie jest w repozytorium git.",
    review_no_git_desc_generic: "Ten projekt nie jest w repozytorium git.",
    review_init_git:         "Zainicjuj repozytorium git",
    review_initializing:     "Inicjowanie...",
    review_agent_offline:    "Agent offline",
    review_agent_offline_desc: "Agent nie jest połączony. Uruchom proces agenta, aby włączyć funkcje git.",
    review_error:            "Błąd wczytywania danych git",
    review_dismiss_error:    "Zamknij",
    review_merge_required:   "Wymagane scalanie",
    review_merge_required_desc: "Ten pull wymaga scalania (gałęzie się rozeszły lub masz niezatwierdzone zmiany). Nic nie zostało zmienione. Rozpocznij scalanie, aby pogodzić.",
    review_start_merge:      "Rozpocznij scalanie",
    review_merging:          "Scalanie...",
    review_identity_required: "Wymagana tożsamość Git",
    review_identity_required_desc: "Podaj imię i e-mail, aby utworzyć commit scalający.",
    review_identity_name:    "Imię",
    review_identity_email:   "E-mail",
    review_save_identity:    "Zapisz i scal",
    review_saving_identity:  "Zapisywanie...",
    review_retry:            "Spróbuj ponownie",
    review_no_branch:        "brak gałęzi",
    review_new_branch_btn:   "+",
    review_new_branch_dialog_title: "Utwórz nową gałąź",
    review_new_branch_placeholder: "Nazwa gałęzi",
    review_new_branch_option:       "Nowa gałąź",
    review_create_branch:    "Utwórz",
    review_creating_branch:  "Tworzenie...",
    review_vault:                   "Vault",
    vault_configure_banner:         "Konfiguruj vault",
    vault_configure_modal_title:    "Konfiguruj Vault",
    vault_add_new:                  "Dodaj vault",
    vault_unnamed:                  "Bez nazwy",
    vault_name_label:               "Nazwa",
    vault_engine_label:             "Silnik",
    vault_engine_local_folder:      "Lokalny folder",
    review_branch_search_placeholder: "Szukaj gałęzi...",
    review_branch_no_results:       "Brak wyników",
    review_commits_ahead:           "Commity przed zdalnym",
    review_commits_behind:          "Commity za zdalnym",
    review_switch_branch_title:             "Zmień gałąź",
    review_switch_branch_switch_btn:        "Przełącz na",
    review_switch_branch_checkout_current_btn: "Checkout bieżącej",
    review_commit_placeholder: "Wiadomość commita",
    review_commit_btn:       "Commit",
    review_commit_merge_btn: "Zatwierdź scalanie",
    review_merge_in_progress: "Scalanie w toku — zatwierdź, aby je zakończyć.",
    review_merge_in_progress_banner: "Scalanie w toku — rozwiąż konflikty i zatwierdź albo przerwij, aby przywrócić poprzedni stan.",
    code_merge_in_progress: "Trwa scalanie — rozwiąż konflikty i zatwierdź",
    review_abort_merge:       "Przerwij",
    review_aborting:         "Przerywanie...",
    review_committing:       "Commitowanie...",

    review_remove_file_title:   "Przywróć zmiany",
    review_remove_file_confirm: "Przywrócić zmiany do \"{path}\"? Tej operacji nie można cofnąć.",
    review_remove_file_btn:     "Przywróć",

    review_checkout_conflict_title: "Konflikt przełączania",
    review_checkout_conflict_desc:  "Lokalne zmiany zostałyby nadpisane przy przełączeniu na \"{branch}\". Utwórz stash, aby je zachować przed przełączeniem.",
    review_stash_placeholder:       "Nazwa stasha (opcjonalnie)",
    review_stash_and_switch:        "Stash i przełącz",
    review_stashing:                "Tworzenie stasha...",

    tabs_close_tab:                 "Zamknij zakładkę",
    tabs_close_other_tabs:          "Zamknij pozostałe zakładki",
    tabs_close_all_tabs:            "Zamknij wszystkie zakładki",

    ssh_keys_empty:                 "Brak kluczy SSH.",
    ssh_keys_name_label:            "Nazwa",
    ssh_keys_name_placeholder:      "np. klucz wdrożeniowy",
    ssh_keys_private_label:         "Klucz prywatny",
    ssh_keys_private_placeholder:   "-----BEGIN OPENSSH PRIVATE KEY-----",
    ssh_keys_public_label:          "Klucz publiczny (opcjonalnie)",
    ssh_keys_public_placeholder:    "ssh-ed25519 AAAA...",
    ssh_keys_upload:                "Wgraj plik",
    ssh_keys_enter_manually:        "Wpisz ręcznie",
    ssh_keys_add:                   "Dodaj klucz",
    ssh_keys_add_new:               "Dodaj nowy klucz",
    ssh_keys_new_title:             "Nowy klucz SSH",
    ssh_keys_cancel:                "Anuluj",
    ssh_keys_use:                   "Użyj",
    ssh_keys_active:                "Aktywny",
    ssh_keys_remove:                "Usuń",
    ssh_keys_remove_title:          "Usuń klucz SSH",
    ssh_keys_remove_confirm:        "Usunąć „{name}”? Tej operacji nie można cofnąć.",
};
